import { render, staticRenderFns } from "./BowFormContact.vue?vue&type=template&id=305f0232&"
import script from "./BowFormContact.vue?vue&type=script&lang=js&"
export * from "./BowFormContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowHeading: require('/workspace/components/atoms/BowHeading/BowHeading.vue').default,BowSkeleton: require('/workspace/components/atoms/BowSkeleton/BowSkeleton.vue').default,BowText: require('/workspace/components/atoms/BowText/BowText.vue').default,BowInput: require('/workspace/components/atoms/BowInput/BowInput.vue').default,BowButton: require('/workspace/components/atoms/BowButton/BowButton.vue').default,BowMap: require('/workspace/components/atoms/BowMap/BowMap.vue').default,BowSticky: require('/workspace/components/base/BowSticky/BowSticky.vue').default})
